export const authKeys = {
  /** The practices the signed-in (non-agency) user belongs to — the top-bar practice switcher's list. */
  practices: () => ['auth', 'practices'] as const,
};
